import JiraSoftwareNav from "../software-jira-navbar";

import JiraEnhancedAboveNavBanners from "./above-nav-butterbar";
import BlogsSection from "./blogs";
import CTASection from "./cta";
import DevOpsSection from "./dev-ops";
import IntegrationSection from "./integrations";
import LoggedInHeroSection from "./logged-in-hero/logged-in-hero";
import JiraPlainBanners from "./plain-banners";
import ScalingSection from "./scaling";
import TabsSection from "./tabs";
import WorkflowSection from "./workflow";

export {
    JiraEnhancedAboveNavBanners,
    JiraPlainBanners,
    BlogsSection,
    CTASection,
    DevOpsSection,
    LoggedInHeroSection,
    IntegrationSection,
    ScalingSection,
    JiraSoftwareNav,
    TabsSection,
    WorkflowSection
};
